import { useMemo } from 'react';
import { DocumentUploadsStatus, DocumentUploadsValidationError, } from '../types/document-uploads';
import { useGetLocalizedString } from './useGetLocalizedString';
import { MAX_ALLOWED_FILE_SIZE_MB } from '../state/slices/slice-document-uploads';
export var useDocumentUploadsErrorText = function (document) {
    var getLocalizedString = useGetLocalizedString();
    var validationErrorTextMap = useMemo(function () {
        var _a;
        return (_a = {},
            _a[DocumentUploadsValidationError.MAX_FILE_SIZE_EXCEEDED] = {
                errorTitle: getLocalizedString('DOCUMENT_UPLOAD_FILE_SIZE_EXCEEDED'),
                errorDescription: getLocalizedString('DOCUMENT_UPLOAD_TRY_FILE_BELOW_SIZE_MB', [MAX_ALLOWED_FILE_SIZE_MB.toString()]),
            },
            _a[DocumentUploadsValidationError.UNSUPPORTED_FILE_TYPE] = {
                errorTitle: getLocalizedString('DOCUMENT_UPLOAD_UNSUPPORTED_FILE_TYPE'),
                errorDescription: getLocalizedString('DOCUMENT_UPLOAD_TRY_FILE_IMAGE_PDF'),
            },
            _a);
    }, [getLocalizedString]);
    if (document.status === DocumentUploadsStatus.ERROR) {
        return validationErrorTextMap[document.validationError];
    }
    if (document.status === DocumentUploadsStatus.FAILED) {
        return {
            // Default values for the generic failure case (e.g. network error)
            errorTitle: getLocalizedString('DOCUMENT_UPLOAD_FAILED'),
            errorDescription: getLocalizedString('DOCUMENT_UPLOAD_FAILED_FOLLOW_UP'),
        };
    }
    // For any non-error/failure types
    return {};
};
